/**
 * Returns allocation cache tags affected by a Purchase Order update.
 *
 * @param {*} _result Mutation result.
 * @param {*} _error Mutation error.
 * @param {{data: Object}} arg Mutation arguments.
 * @return {Array<string>} Tags that must be invalidated.
 */
export function purchaseAllocationInvalidationTags(_result, _error, arg) {
  const lines = arg?.data?.purchase_order_line_items ?? [];
  const quantityChanged = lines.some(line =>
    Object.prototype.hasOwnProperty.call(line, "ordered_qty"),
  );

  return quantityChanged ? ["allocatedPurchaseList"] : [];
}
